export const sizes = {
  thumb: {
    width: 108,
    height: 108
  },
  mobile: {
    width: 290,
    height: 290
  },
  tab: {
    width: 500,
    height: 500
  },
  web: {
    width: 800,
    height: 800
  },
  largeweb: {
    width: 1200,
    height: 1200
  },
  original: {
    width: Infinity,
    height: Infinity
  }
};

export const shutterStock = {
  maxSize: sizes.web.width
};
